var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.7 7.1c0-.6-.4-1-1-1h-3.1V4.6C16.6 3.2 15.5 2 14 2h-3.3C9.3 2 8.1 3.2 8.1 4.6v1.5H5c-.6 0-1 .4-1 1 0 .5.4.9.9 1l1.4 12.3c.2.9 1 1.6 1.9 1.6h8.4c.9 0 1.7-.7 1.8-1.6l1.4-12.3c.5-.1.9-.5.9-1M10.1 4.6c0-.3.3-.6.6-.6H14c.4 0 .6.3.6.6v1.5h-4.5zM16.4 20h-8L6.9 8.1h10.8zM14.9 9.4c-.5-.1-1 .3-1.1.9l-.8 7.3c-.1.5.3 1 .9 1.1h.1c.5 0 .9-.4 1-.9l.8-7.4c.1-.5-.3-1-.9-1m-6 1.1c0-.6.3-1.1.9-1.1.5-.1 1 .3 1.1.9l.8 7.4c0 .5-.4 1-.9 1.1h-.1c-.5 0-.9-.4-1-.9z",
    clipRule: "evenodd"
  })));
};
export default SvgDelete;